export const MOCK_DATA: Record<string, any>[] = [
  {
    "required": true,
    "id": "6c240b18-e6f6-4569-a732-4bc9829298c5",
    "organization_attribution_guid": "59910e92-473d-4889-8d82-701a05a38967",
    "deleted": 1,
    "created_date": "2026-07-30T19:42:52.377Z",
    "updated_date": "2026-07-30T19:43:01.722Z",
    "attribution_id": "7f3f7af7-f01f-43e4-8fcc-822fc637bcb9",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": true,
    "id": "81fa91de-2052-489e-a71a-71486142261f",
    "organization_attribution_guid": "aac8c8bc-dc59-4cab-bd5b-ba67e8ab2c47",
    "deleted": 0,
    "created_date": "2026-07-30T19:43:06.372Z",
    "updated_date": "2026-07-30T19:43:06.372Z",
    "attribution_id": "7f3f7af7-f01f-43e4-8fcc-822fc637bcb9",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "ade979ca-0289-4811-a4c7-556a28273564",
    "organization_attribution_guid": "8103a45f-e7a7-4b3f-b3cd-e1430e983123",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "attribution_id": "cd35ae00-58e4-4130-90f3-6c002d497011",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "f40814d8-9f72-4e36-85a0-0ccb137533c1",
    "organization_attribution_guid": "919ae7ba-2aef-4039-ae86-e06ab1e540fd",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "attribution_id": "91a157f8-a478-4922-a25e-4675a7557f2b",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "72a3e781-678c-4a41-a27e-a3d876f9d525",
    "organization_attribution_guid": "cf5e4827-e047-41d7-85bc-fb5fba95839d",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z",
    "attribution_id": "e8b291a9-052b-416f-8d2f-259b2342ee30",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "8094c98a-9f43-481c-8a58-f638e25027e7",
    "organization_attribution_guid": "6e759a55-7567-4982-883f-b38ceef98f9e",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "attribution_id": "71899e52-1584-446d-b6ae-79b17d7a1e99",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "67702c56-5067-4c14-a22f-e5efe8796c6a",
    "organization_attribution_guid": "57cccf22-8499-454f-ba5c-2621bde565b1",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "attribution_id": "871bd527-e0ae-4f2a-b958-c31cf2828574",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  },
  {
    "required": false,
    "id": "94e704ee-a491-4158-8ef9-822a9f450145",
    "organization_attribution_guid": "4254a950-67b3-4823-b570-15d3b96a6526",
    "deleted": 0,
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z",
    "attribution_id": "ffcb16cb-75af-4db8-b970-b4fbc2184a14",
    "organization_id": "62f17051-00f6-4e2e-90fe-3f80981e27f4"
  }
];